/**
 * Format phone number
 */
import parsePhoneNumber from 'libphonenumber-js'
const formatPhoneNum = function (val, country = 'CA') {
  if (typeof val !== 'string') {
    return val
  }

  const num = parsePhoneNumber(val, {
    defaultCountry: country,
    extract: false
  })

  if (!num) return val

  const telFmt = /^\+\d+/.test(val)
    ? 'INTERNATIONAL'
    : 'NATIONAL'

  if (!num.isValid()) return val

  const result = num.format(telFmt)
  if (country === 'AU') {
    return auFormat(val, result)
  }
  return result
}

// special case to match CLUSTER-7558 specs
// some cases in libphonenumber is different
// so fix it here
function auFormat (val, defaultNum) {
  let re = val.match(/^(04\d{2})(\d{3})(\d{3})$/)
  if (re) {
    return `(${re[1]}) ${re[2]} ${re[3]}`
  }

  re = val.match(/^(13\d)(\d{3})$/)
  if (re) {
    return `${re[1]} ${re[2]}`
  }
  return defaultNum
}

export default formatPhoneNum
